import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button, Loading } from '../root/components/common'
import CloseIcon from '@material-ui/icons/Close'
import * as actions from './actions'
import { createSelector } from 'reselect'
import { getAvailableDevices } from './selectors'
import { DevicesTree } from './components/devices-tree/devices-tree'
import { useTreeUtils } from '../root/components/common/locations-tree/tree-utils'
import { useCallback } from 'react'
import { debounce } from 'lodash'
import { useState } from 'react'
import { useMemo } from 'react'
import { sortAvailableDevicesTree } from './utils/sort-available-devices-tree'

const getAvailableDevicesSelector = createSelector(
    state => state.locations.availableDevices,
    state => state.main.locale,
    (availableDevices, locale) => getAvailableDevices(availableDevices, locale)
)

const getAvailableNetworkDevicesSelector = createSelector(
    state => state.locations.availableNetworkDevices,
    state => state.main.locale,
    (availableNetworkDevices, locale) =>
        getAvailableDevices(availableNetworkDevices, locale)
)

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%'
    },
    topButtonsWrapper: {
        display: 'flex',
        alignItems: 'end',
        justifyContent: 'flex-end',
        marginBottom: 8
    },
    closeIconWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    closeIcon: {
        width: 16,
        height: 16,
        marginLeft: 4
    }
}))

function DevicesToMove(props) {
    const classes = useStyles()

    const { setIsDevicesToMoveMode, selectedLocation, deviceType } = props
    const { locale } = useSelector(state => state.main)
    const [search, setSearch] = useState('')
    const { isLocationsSidebarLoading, location } = useSelector(
        state => state.locations
    )
    const isNetworkDevice = deviceType === 'network'
    const { availableDevicesTree } = useSelector(
        isNetworkDevice
            ? getAvailableNetworkDevicesSelector
            : getAvailableDevicesSelector
    )

    const sortedAvailableDevicesTree = useMemo(
        () => sortAvailableDevicesTree(availableDevicesTree),
        [availableDevicesTree]
    )

    const treeUtils = useTreeUtils(sortedAvailableDevicesTree)

    const dispatch = useDispatch()

    const onCancelClick = () => {
        setIsDevicesToMoveMode(false)
        if (selectedLocation) {
            dispatch(
                isNetworkDevice
                    ? actions.locationNetworkDevicesRequest(selectedLocation)
                    : actions.locationDevicesRequest(selectedLocation)
            )
        }
    }

    const onMoveDeviceClick = device => {
        const deviceId = device.id
        dispatch(
            isNetworkDevice
                ? actions.moveToLocationNetworkDevices(deviceId)
                : actions.moveToLocationDevices(deviceId)
        )
        treeUtils.deleteNode(deviceId)
    }

    const handleSearch = useCallback(
        debounce(v => {
            setSearch(v)
            isNetworkDevice
                ? dispatch(
                      actions.availableNetworkDevicesRequest(
                          selectedLocation,
                          location.customer_id,
                          {
                              search: v
                          }
                      )
                  )
                : dispatch(
                      actions.availableDevicesRequest(
                          selectedLocation,
                          location.customer_id,
                          {
                              search: v
                          }
                      )
                  )
        }, 300),
        []
    )

    return (
        <div className={classes.wrapper}>
            <div className={classes.topButtonsWrapper}>
                <Button onClick={onCancelClick}>
                    <div>{locale.common.done}</div>
                    <div className={classes.closeIconWrapper}>
                        <CloseIcon className={classes.closeIcon} />
                    </div>
                </Button>
            </div>

            <DevicesTree
                isLoading={isLocationsSidebarLoading}
                search={search}
                allExpanded={Boolean(search)}
                onSearch={handleSearch}
                treeUtils={treeUtils}
                onIconClick={onMoveDeviceClick}
            />
        </div>
    )
}

export default withRouter(DevicesToMove)
